if (!customElements.get("glow-comparison-slider")) {
  class GlowComparisonSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = false;
    }

    connectedCallback() {
      this.slideContainer = this.querySelector(".glow-comparison__table");
      this.slideInner = this.querySelector(".glow-comparison__slides");
      this.slideControls = this.querySelector(".m-slider-controls");
      this.slideItems = Array.from(this.querySelectorAll(".glow-comparison__slide"));

      this.init();
      document.addEventListener("matchMobile", () => this.init());
      document.addEventListener("unmatchMobile", () => this.init());
    }

    init() {
      if (MinimogTheme.config.mqlMobile) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (!this.slideContainer || !this.slideInner || typeof this.slider === "object") return;

      this.slideContainer.classList.add("swiper-container");
      this.slideInner.classList.add("swiper-wrapper");
      this.slideItems.forEach((item) => item.classList.add("swiper-slide"));

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        autoHeight: true,
        loop: false,
        threshold: 2,
        pagination: this.slideControls
          ? {
              el: this.slideControls.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
              renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
              },
            }
          : false,
      });
    }

    destroySlider() {
      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
        this.slider = false;
      }

      this.slideContainer && this.slideContainer.classList.remove("swiper-container");
      this.slideInner && this.slideInner.classList.remove("swiper-wrapper");
      this.slideItems.forEach((item) => item.classList.remove("swiper-slide"));
    }
  }

  customElements.define("glow-comparison-slider", GlowComparisonSlider);
}
